import React from "react";
import { Menu, MenuItem } from "@mui/material";
import { Backup, FileCopy, Settings, Delete } from "@mui/icons-material";

/**
 * Context menu for site actions
 */
const SiteActionMenu = ({
  anchorEl,
  open,
  onClose,
  selectedSite,
  onBackup,
  onClone,
  onSettings,
  onDelete,
}) => {
  return (
    <Menu anchorEl={anchorEl} open={open} onClose={onClose}>
      <MenuItem
        onClick={() => {
          onBackup(selectedSite);
          onClose();
        }}
      >
        <Backup sx={{ mr: 1, fontSize: 20 }} />
        Create Backup
      </MenuItem>
      <MenuItem
        onClick={() => {
          onClone(selectedSite);
          onClose();
        }}
      >
        <FileCopy sx={{ mr: 1, fontSize: 20 }} />
        Clone Site
      </MenuItem>
      <MenuItem
        onClick={() => {
          onSettings(selectedSite);
          onClose();
        }}
      >
        <Settings sx={{ mr: 1, fontSize: 20 }} />
        Site Settings
      </MenuItem>
      <MenuItem
        onClick={() => {
          onDelete(selectedSite);
          onClose();
        }}
        sx={{ color: "error.main" }}
      >
        <Delete sx={{ mr: 1, fontSize: 20 }} />
        Delete Site
      </MenuItem>
    </Menu>
  );
};

export default SiteActionMenu;
